<template>
    <div>
        <div ref="trigger">
        <slot>
            <ui-button 
                ref="btn"
                :disabled="disabled"
                icon="person" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Contact</ui-button>
        </slot>
        </div>
        <ui-popover ref="popover" :trigger="$refs.trigger" v-show="!disabled">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Related Contact</div>
            <div style="padding: 1rem 1rem;">
                <div style="width: 15rem;">
                    <keen-contact-picker
                        :can-create="false"
                        v-model="selected"
                    ></keen-contact-picker>
                    <ui-button :loading="isLoading" @click="save">Save</ui-button>
                    <ui-button v-show="selected.id" :disabled="isLoading" @click="destroy" color="red">Remove</ui-button>
                </div>
            </div>
        </ui-popover>
    </div>
</template>

<script>
    import { ContactTypes } from '../../../classes/Api/Contact'

    export default {
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            contact: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            }
        },
        mounted() {
            if (this.contact) {
                this.selected = this.contact;
            }
        },
        watch: {
            contact: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = (newVal === null ? {} : newVal);
                    }
                },
                deep: true,
            },
        },
        data() {
            return {
                selected: {},
                users: []
            }
        },
        methods: {
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', null, null);
            },
            reset() {
                this.$refs['popover'].close();
            },
            show() {
                this.$refs.popover.open()
            }
        }
    }
</script>